(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/init.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/init.js');
'use strict';

const _svs$app$ReactRouter = svs.app.ReactRouter,
  PlayerRouter = _svs$app$ReactRouter.PlayerRouter,
  Route = _svs$app$ReactRouter.Route;
const baseUrl = svs.core.data.baseUrl;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const SuspensionReduxProvider = svs.spelpaus.store.SuspensionReduxProvider;
const ROUTE = svs.spelpaus.constants.ROUTE;
const Suspension = svs.spelpaus.pages.firstPage.Suspension;
const SvsSuspension = svs.spelpaus.pages.svsSuspension.SvsSuspension;
svs.spelpaus.init = () => {
  const router = React.createElement(PlayerRouter, {
    basename: baseUrl,
    className: "bg-white",
    withRouter: true
  }, React.createElement(SuspensionReduxProvider, null, React.createElement(ErrorBoundary, null, React.createElement(Route, {
    component: Suspension,
    exact: true,
    path: ROUTE.home
  }), React.createElement(Route, {
    component: SvsSuspension,
    exact: true,
    path: ROUTE.svsSuspension
  }))));
  ReactDOM.render(router, document.getElementsByClassName('js-react-container')[0]);
};
svs.spelpaus.init();

 })(window);